import { useAgencyVATRate } from 'modules/core/vat';

export function useCreateDefaults(): Record<string, unknown> {
  const vat_rate = useAgencyVATRate();
  return {
    // display_number: string;
    state: 'DRAFT' as const,

    checkout_date: null,
    payment_date: null,
    comment: '',
    type: 'INVOICE' as const,
    alt_currency: null,
    alt_vat_amount: null,
    alt_total: null,
    vat_rate,
    // sub_total: string;
    vat_amount: null,
    total: null,
    attachments: [],
    clients: [],
    finance_period: null,
  };
}
